import { Card, CardContent, Typography } from "@mui/material";
import { useStyle } from "./style";
import { useRecoilValue } from "recoil";
import { systemCurrencyState } from "@/store";
import { useQuoteGetData } from "@/pages-components/quote-new/use-quote-get-data";
import { useTheme } from "@/contexts/theme";

const HP_BLUE = "#024AD8";

interface ICardProps {
  text?: string;
  number?: string | number;
  icon?: JSX.Element;
  withCurrency?: boolean;
  /** Modern theme only: render as a production-floor KPI card. */
  variant?: "kpi";
  /** KPI color tone (waiting, approved, urgent, time, ink). */
  tone?: string;
}

const TotalCardComponent = ({
  text,
  number,
  icon,
  withCurrency = false,
  variant,
  tone,
}: ICardProps) => {
  const { classes } = useStyle();
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  const systemCurrency = useRecoilValue<any>(systemCurrencyState);
  const { getCurrencyUnitText } = useQuoteGetData();

  if (currentTheme === "modern" && variant === "kpi") {
    return (
      <div className="gm-pf-kpi" data-tone={tone}>
        <span className="gm-pf-kpi-icon" aria-hidden>
          {icon}
        </span>
        <span className="gm-pf-kpi-copy">
          <em>{text}</em>
          <strong>
            {number}
            {withCurrency && (
              <span className="gm-pf-kpi-unit">
                {getCurrencyUnitText(systemCurrency)}
              </span>
            )}
          </strong>
        </span>
      </div>
    );
  }

  if (isHpClient) {
    return (
      <Typography
        component="div"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          height: "40px",
          padding: "0 4px",
          fontFamily: "'Forma DJR UI', sans-serif",
          fontWeight: 700,
          fontSize: "16px",
          lineHeight: "20px",
          color: HP_BLUE,
        }}
      >
        <span>{text}</span>
        <span style={{ fontWeight: 700 }}>
          {number}
          {withCurrency && (
            <Typography
              component="span"
              sx={{ fontSize: "0.7em", verticalAlign: "bottom", ml: 0.2 }}
            >
              {getCurrencyUnitText(systemCurrency)}
            </Typography>
          )}
        </span>
      </Typography>
    );
  }

  return (
    <Card sx={classes.cardContainerStyle}>
      <CardContent style={classes.ticketContent}>
        <Typography sx={classes.totalTextStyle} color="#FFFFFF">
          {icon}
          {text}
        </Typography>
        <Typography sx={classes.numStyle} color="#FFFFFF">
          {number}
          {withCurrency && (
            <Typography
              component="span"
              sx={{ fontSize: "0.7em", verticalAlign: "bottom", ml: 0.2 }}
            >
              {getCurrencyUnitText(systemCurrency)}
            </Typography>
          )}
        </Typography>
      </CardContent>
    </Card>
  );
};

export { TotalCardComponent };
